<template>
    <div class="contenedor_modal mods_edicion_producto">
        <div class="contenedor_modal_cuerpo mods_cuerpo_edicion_producto">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" v-shortkey="['esc']" @shortkey="cerrar" variant="danger"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>


            <b-container fluid="">
                <b-row>
                    <div class="col-sm-7 mt-3">
                        <div class="foto_producto">
                            <img :src="`${URL_SERVIDOR + id_foto_producto}`" alt="">

                        </div>
                    </div>
                    <div class="col-sm-5 mt-3">
                        <div class="row">
                            <form @submit.prevent="actualizar" style="width: 100%">
                                <div class="col-sm-12 mt-1">
                                    <h3>
                                        Edición producto
                                    </h3>
                                </div>
                                <div class="col-sm-12 mt-1">
                                    <label for="" class="form-label">Nombre</label>
                                    <input type="text" class="form-control form-control-sm" v-model="nombre">
                                </div>
                                <div class="col-sm-12 mt-2">
                                    <label for="" class="form-label">Precio Costo</label>
                                    <input type="number" step="0.01" min="1" class="form-control form-control-sm"
                                        v-model="precio_costo">
                                </div>
                                <div class="col-sm-12 mt-2">
                                    <label for="" class="form-label">Precio Venta</label>
                                    <input type="number" step="0.01" min="1" class="form-control form-control-sm"
                                        v-model="precio_venta">
                                </div>
                                <div class="col-sm-12 mt-2">
                                    <label for="" class="form-label">Precio Efectivo</label>
                                    <input type="number" step="0.01" min="1" class="form-control form-control-sm"
                                        v-model="precio_efectivo">
                                </div>
                                <div class="col-sm-12 mt-2">
                                    <label for="" class="form-label">Descripción</label>
                                    <input type="text" class="form-control form-control-sm" v-model="descripcion">
                                </div>
                                <div class="col-sm-12 mt-2">
                                    <label for="" class="form-label">Foto producto</label>
                                    <!-- <input type="number" step="0.01" min="1" class="form-control form-control-sm"> -->
                                    <b-form-file v-model="foto_producto" required :state="Boolean(foto_producto)"
                                        placeholder="Elije archivo" drop-placeholder="Arrastra archivo aquí..."
                                        size="sm"></b-form-file>
                                </div>
                                <div class="col-sm-12 mt-4">
                                    <b-button type="submit" block size="sm" variant="outline-dark"
                                        v-if="permisos['sucursales.productos']?.actualizar || datos_usuario.parametros.roles.includes('ROOT')">
                                        <i class="fas fa-save"></i> Actualizar
                                    </b-button>
                                    <b-button type="submit" block size="sm" variant="outline-dark" v-else disabled>
                                        <i class="fas fa-save"></i> Actualizar
                                    </b-button>
                                </div>

                            </form>
                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { atexto } from '@/components/functions/alertas';
    import { mapActions, mapGetters, mapState } from 'vuex';
    import axios from 'axios'

    export default {
        name: 'EditarProducto',
        computed: {
            ...mapState(['producto_seleccionado', 'permisos', 'datos_usuario']),
            ...mapGetters(['URL_SERVIDOR', 'TOKEN_FORMATEADO'])
        },
        data() {
            return {
                nombre: '',
                precio_costo: '',
                precio_venta: '',
                precio_efectivo: '',
                descripcion: '',
                id_foto_producto: '',
                foto_producto: null
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async actualizar() {

                let formData = new FormData();
                formData.append('files', this.foto_producto)

                let upl = await axios.post(`${this.URL_SERVIDOR}/api/upload`, formData, this.TOKEN_FORMATEADO)

                let id_foto = upl.data[0].id
                let formatos = upl.data[0].formats

                if (upl.status == 200 || upl.status == 201) {

                    let f = {
                        api: `articulos/${this.producto_seleccionado.document_id ?? this.producto_seleccionado.documentId}`,
                        formulario: {
                            nombre: this.nombre.trim().toUpperCase(),
                            precio_costo: this.precio_costo,
                            precio_venta: this.precio_venta,
                            precio_efectivo: this.precio_efectivo,
                            descripcion: this.descripcion.trim(),
                            id_foto,
                            formatos
                        }
                    }

                    await this.actualizar_data(f)
                    this.$emit('actualizar_producto')

                    // Actualizar la imagen inmediatamente con los nuevos formatos
                    if (Object.keys(formatos).includes('large')) {
                        this.id_foto_producto = formatos.large.url
                    } else if (Object.keys(formatos).includes('medium')) {
                        this.id_foto_producto = formatos.medium.url
                    } else if (Object.keys(formatos).includes('small')) {
                        this.id_foto_producto = formatos.small.url
                    } else {
                        this.id_foto_producto = formatos.thumbnail.url
                    }

                } else {
                    atexto({
                        titulo: 'Error!',
                        cuerpo: 'Hubo un error al subir la imagen',
                        icono: 'error'
                    })
                }

            },
            ...mapActions(['actualizar_data'])
        },
        mounted() {
            this.nombre = this.producto_seleccionado.nombre
            this.precio_costo = this.producto_seleccionado.precio_costo
            this.precio_venta = this.producto_seleccionado.precio_venta
            this.precio_efectivo = this.producto_seleccionado.precio_efectivo
            this.descripcion = this.producto_seleccionado.descripcion

            if (Object.keys(this.producto_seleccionado.formatos).includes('large')) {
                this.id_foto_producto = this.producto_seleccionado.formatos.large.url
            } else if (Object.keys(this.producto_seleccionado.formatos).includes('medium')) {
                this.id_foto_producto = this.producto_seleccionado.formatos.medium.url
            } else if (Object.keys(this.producto_seleccionado.formatos).includes('small')) {
                this.id_foto_producto = this.producto_seleccionado.formatos.small.url
            } else {
                this.id_foto_producto = this.producto_seleccionado.formatos.thumbnail.url
            }


        },
    }
</script>

<style>

    .mods_edicion_producto {
        background-color: rgba(0, 0, 0, 0.1) !important;
    }

    .mods_cuerpo_edicion_producto {
        height: 600px !important;
        width: 700px !important;
    }

    .foto_producto {
        width: 100%;
        height: 500px;
        border: 1px solid #e9e9e9;
        border-radius: 4px;

    }

    .foto_producto img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        padding: 10px;
    }
</style>